<template>
  <section
    :id
    :class="{
      container: !parentType,
    }"
  >
    <div class="relative aspect-video">
      <iframe
        v-if="src"
        :title="title"
        :src="src"
        loading="lazy"
        :aria-label="title"
        scrolling="no"
        frameborder="0"
        allowfullscreen
        class="size-full"
        sandbox="allow-top-navigation allow-top-navigation-by-user-activation allow-downloads allow-scripts allow-same-origin allow-popups"
      />
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { ParagraphIframeFragment } from '#graphql-operations'

const props = defineProps<ParagraphIframeFragment>()

const { parentType, index, siblings } = defineBlokkli({
  bundle: 'iframe',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
})

const src = computed(() => props.link?.uri?.path)

const id = useParagraphAnchorId(index, siblings)
</script>
